export default __webpack_public_path__ + "static/media/h3-3.7e48c006.jpg";